<template>
  <div class="quiz-response">
    <single-response-item :questionId="questionId" />
    <div class="cta">
      <vv-button @click="nextQuestion">{{ nextLabel }}</vv-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { VvButton } from '@/components/common'
import SingleResponseItem from './SingleResponseItem'

export default {
  name: 'SingleResponse',
  components: { VvButton, SingleResponseItem },
  computed: {
    ...mapGetters(['isLastQuizQuestion']),
    nextLabel() {
      return this.isLastQuizQuestion ? this.$t('quiz.lastQuestion') : this.$t('quiz.nextQuestion')
    },
    questionId() {
      return this.$store.state.route.params.questionId
    }
  },
  methods: {
    nextQuestion() {
      this.$emit('next')
    }
  }
}
</script>

<style lang="scss" scoped>
.response {
  margin-bottom: 30px;
}

.explanation {
  margin-bottom: 30px;
}
</style>
